/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import useSwr from 'swr';
import type { SWRConfiguration, Key } from 'swr';
import type {
  AuthLoginDto,
  AuthEmailLoginDto,
  AuthGoogleLoginSubmitDto,
  AuthForgotPasswordDto,
  AuthResetPasswordDto,
} from '../nabisNYWebAPI.schemas';

export const authControllerIsAuthenticated = (options?: AxiosRequestConfig): Promise<AxiosResponse<boolean>> => {
  return axios.get(`/api/v1/auth/is-authenticated`, options);
};

export const getAuthControllerIsAuthenticatedKey = () => [`/api/v1/auth/is-authenticated`] as const;

export type AuthControllerIsAuthenticatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof authControllerIsAuthenticated>>
>;
export type AuthControllerIsAuthenticatedQueryError = AxiosError<unknown>;

export const useAuthControllerIsAuthenticated = <TError = AxiosError<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof authControllerIsAuthenticated>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  axios?: AxiosRequestConfig;
}) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAuthControllerIsAuthenticatedKey() : null));
  const swrFn = () => authControllerIsAuthenticated(axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const authControllerLogin = (
  authEmailLoginDto: AuthEmailLoginDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthLoginDto>> => {
  return axios.post(`/api/v1/auth/login`, authEmailLoginDto, options);
};

export const authControllerRefreshToken = (options?: AxiosRequestConfig): Promise<AxiosResponse<AuthLoginDto>> => {
  return axios.get(`/api/v1/auth/refresh`, options);
};

export const getAuthControllerRefreshTokenKey = () => [`/api/v1/auth/refresh`] as const;

export type AuthControllerRefreshTokenQueryResult = NonNullable<Awaited<ReturnType<typeof authControllerRefreshToken>>>;
export type AuthControllerRefreshTokenQueryError = AxiosError<unknown>;

export const useAuthControllerRefreshToken = <TError = AxiosError<unknown>>(options?: {
  swr?: SWRConfiguration<Awaited<ReturnType<typeof authControllerRefreshToken>>, TError> & {
    swrKey?: Key;
    enabled?: boolean;
  };
  axios?: AxiosRequestConfig;
}) => {
  const { swr: swrOptions, axios: axiosOptions } = options ?? {};

  const isEnabled = swrOptions?.enabled !== false;
  const swrKey = swrOptions?.swrKey ?? (() => (isEnabled ? getAuthControllerRefreshTokenKey() : null));
  const swrFn = () => authControllerRefreshToken(axiosOptions);

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions);

  return {
    swrKey,
    ...query,
  };
};

export const authControllerGoogleLogin = (
  authGoogleLoginSubmitDto: AuthGoogleLoginSubmitDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthLoginDto>> => {
  return axios.post(`/api/v1/auth/google`, authGoogleLoginSubmitDto, options);
};

export const authControllerRequestPasswordReset = (
  authForgotPasswordDto: AuthForgotPasswordDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(`/api/v1/auth/request-password-rest`, authForgotPasswordDto, options);
};

export const authControllerResetPassword = (
  authResetPasswordDto: AuthResetPasswordDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(`/api/v1/auth/reset-password`, authResetPasswordDto, options);
};
